import { lazy, ComponentType } from 'react'

/**
 * Creates a lazy-loaded page component
 *
 * @param importFn - Dynamic import function that returns a module with default or named export
 * @param exportName - Optional named export (if not default export)
 * @returns Lazy-loaded component ready to be rendered
 *
 * @example
 * // Default export
 * const HomePage = createPage(() => import('@pages/user/home/home-page'))
 *
 * @example
 * // Named export
 * const ContentPage = createPage(
 *   () => import('@pages/user/content/content-page'),
 *   'DefaultContentPage'
 * )
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createPage = <T extends ComponentType<any>>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  importFn: () => Promise<any>,
  exportName?: string
): T => {
  if (exportName) {
    return lazy(() => importFn().then(module => ({ default: module[exportName] }))) as unknown as T
  }
  return lazy(importFn) as unknown as T
}
